<div [formGroup]="remarkForm" class="add-remarks-container">
    <h2 class="add-remarks-description fs-2 mb-4">Remarks</h2>
    <span class="reject-title">Please provide a reason for rejecting the request.</span>
    <div class="add-remarks-editor-container">  
        <angular-editor [config]="editorConfig" formControlName="remarks" ></angular-editor>
    </div>
      
    <!-- <button *ngIf="!isReject" class="remarks-btn" (click)="addRemarks()">Add Remarks</button> -->
    <button class="remarks-btn reject-btn" (click)="rejectRequest()">Reject</button>
</div>